/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JunitTestBaseDataParser = /* #__PURE__ */ parsers.object([
    ['program', codecString],
]);
export class JunitTestBaseData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JunitTestBaseDataParser.decode(input).map(res => new JunitTestBaseData(res));
    }
    static unsafeDecode(input) {
        return JunitTestBaseData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestBaseDataParser.encode(data);
    }
    static schema() {
        return JunitTestBaseDataParser.schema();
    }
}
